import { isNullOrUndefined } from './misc_utils';

export const isSignedIn = (token) => {
    return !!(!isNullOrUndefined(token) && !isNullOrUndefined(token.data) && !isNullOrUndefined(token.data.accessToken));
};
